import { inject, Injectable } from '@angular/core';
import { IndicatorStore } from '../../stores/indicator/indicator.state';
import { IndicatorDataStore } from '../../stores/indicatpr-data/indicator-data.state';
import { DataLayerTypeStore } from '../../stores/data-layer-type/data-layer-type.state';
import { DataLayerStore } from '../../stores/data-layer/data-layer.state';
import { makeUniqueStringArray } from '../../utility/array.utility';
import { IndicatorData } from '../../models/indicator-data';
import { DataLayerType } from '../../models/data-layer-type';
import { DataLayer } from '../../models/data-layer';
import { Indicator } from '../../models/indicator';

export type IndicatorOverviewTableRow = {
  data: {
    name: string;
    type?: string | number;
    year?: string | number;
    data?: string | number;
    dataInternal?: number;
    dataExternal?: number;
  };
  children?: IndicatorOverviewTableRow[];
};

@Injectable({
  providedIn: 'root',
})
export class TableServiceService {
  readonly indicatorStore = inject(IndicatorStore);
  readonly dataStore = inject(IndicatorDataStore);
  readonly layerTypeStore = inject(DataLayerTypeStore);
  readonly layerStore = inject(DataLayerStore);
  constructor() {}

  getTableColumns() {
    return [
      { field: 'name', header: 'Name' },
      { field: 'type', header: 'Raum/Standort-Typ' },
      { field: 'year', header: 'Jahre' },
      { field: 'data', header: 'Daten' },
    ];
  }

  indicatorRows() {
    const indicators = this.indicatorStore.withoutSets();
    const rows: IndicatorOverviewTableRow[] = [];

    indicators.forEach((indicator: Indicator) => {
      const data: Record<string, IndicatorData> = this.dataStore.getByIndicator(
        indicator._id
      );
      console.log(data);
      const dataArray = data ? Object.values(data) : [];
      const dataInternal = dataArray.filter(d => !d.published).length;
      const dataExternal = dataArray.filter(d => d.published).length;

      const typeIds = data
        ? makeUniqueStringArray(dataArray.map(item => item.dataLayerType))
        : undefined;
      const layerIds = data
        ? makeUniqueStringArray(dataArray.map(item => item.dataLayer))
        : undefined;
      const row: IndicatorOverviewTableRow = {
        data: {
          name: this.indicatorStore.getFullName(indicator),
          type: typeIds?.length,
          year: layerIds?.length,
          data: dataArray.length,
          dataInternal,
          dataExternal,
        },
      };

      if (typeIds && dataArray.length > 0) {
        row.children = this.getTypeRows(typeIds, indicator._id);
      }

      rows.push(row);
    });
    return rows;
  }

  getTypeRows(
    typeIds: string[],
    indicatorId: string
  ): IndicatorOverviewTableRow[] {
    const types: DataLayerType[] = this.layerTypeStore.getByIds(typeIds);
    const rows: IndicatorOverviewTableRow[] = [];
    types.forEach((type: DataLayerType) => {
      const typeData = this.dataStore.filterByDataLayerTypeAndIndicator(
        type._id,
        indicatorId
      );
      const layerIds = makeUniqueStringArray(
        typeData.map(item => item.dataLayer)
      );
      const dataInternal = typeData.filter(d => !d.published).length;
      const dataExternal = typeData.filter(d => d.published).length;
      rows.push({
        data: {
          name: '',
          type: type.name,
          year: String(layerIds.length) || '',
          data: typeData.length,
          dataInternal,
          dataExternal,
        },
        children: this.getLayerRows(layerIds, indicatorId),
      });
    });
    return rows;
  }

  getLayerRows(
    layerIds: string[],
    indicatorId: string
  ): IndicatorOverviewTableRow[] {
    const rows: IndicatorOverviewTableRow[] = [];
    const layers = this.layerStore.getByIds(layerIds);
    layers.forEach((layer: DataLayer) => {
      const layerData = this.dataStore.getByDataLayerAndIndicator(
        layer._id,
        indicatorId
      );

      rows.push({
        data: {
          name: '',
          type: '',
          year: String(layer.year),
          data: layerData.published ? 'Veröffentlicht' : 'Intern',
        },
      });
    });
    return rows;
  }
}
